import { render, staticRenderFns } from "./password_email.vue?vue&type=template&id=4bc6152d"
import script from "./password_email.vue?vue&type=script&lang=js"
export * from "./password_email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports